<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Videogame</h1>
        <b-modal :active.sync="showGameDetails" :width="800">
          <game-details :game-data="gameDetails" @GameDetailsDelete="doDelete" @GameDetailsEdit="doEdit" />
        </b-modal>
        <b-tabs v-model="selectedTab">

          <b-tab-item label="Giochi">
            <div style="cursor: pointer">
              <b-table :data="rowData" :columns="columns" :striped="true" :paginated="true" :per-page="10" :total="total"
                :hoverable="true" :current-page.sync="page" :pagination-simple="false" :selected.sync="selected"
                :backend-pagination="true" :backend-filtering="true" @filters-change="filtersChange" @select="select"
                @click="rowClicked" @page-change="onPageChange">
                <b-input slot="searchable" slot-scope="props" v-model="props.filters[props.column.field]"
                  placeholder="Cerca..." icon="magnify" size="is-small" />
              </b-table>
            </div>
            <section>
              <div class="buttons">
                <b-button @click="doNew" type="is-primary">Nuovo</b-button>
                <b-button @click="doSearchPast" type="is-primary">Passato</b-button>
                <b-button @click="doSearchPresent" type="is-primary">Presente</b-button>
                <b-button @click="doSearchFuture" type="is-primary">Futuro</b-button>
                <b-button @click="doClearSearch" type="is-primary">Mastrolindo</b-button>
              </div>
            </section>
          </b-tab-item>

          <b-tab-item :disabled="false" label="Dettagli">
            <h1 class="title">
              {{ vGame.Title }}
            </h1>
            <div class="columns">
              <div class="column is-half">
                <b-field label="Titolo">
                  <b-input ref="iTitolo" v-model="vGame.Title" required validation-message="Obbligatorio!"
                    tabindex="1"></b-input>
                </b-field>

                <b-field label="Data Inizio">
                  <b-datepicker ref="iDateBegin" v-model="vGame.DateBeginDate" editable :date-formatter="isoDate" required
                    validation-message="Obbligatorio!">
                  </b-datepicker>
                </b-field>

                <b-field label="Stato">
                  <b-select ref="iStatus" v-model="vGame.StatusId" required validation-message="Obbligatorio!">
                    <option v-for="x in lovs.gameStatus" :value="x.Id" :key="x.Id">
                      {{ x.GameStatus }}
                    </option>
                  </b-select>
                </b-field>

                <b-field label="Data Acquisto">
                  <b-datepicker ref="iDatePurchase" v-model="vGame.DatePurchaseDate" editable :date-formatter="isoDate"
                    required validation-message="Obbligatorio!">
                  </b-datepicker>
                </b-field>

              </div>

              <div class="column">
                <b-field label="Titolo originale">
                  <b-input ref="iTitoloOr" v-model="vGame.OriginalTitle" required validation-message="Obbligatorio!"
                    tabindex="2"></b-input>
                </b-field>

                <b-field label="Data Fine">
                  <b-datepicker ref="iDateEnd" v-model="vGame.DateEndDate" editable :date-formatter="isoDate"
                    validation-message="Obbligatorio!">
                  </b-datepicker>
                </b-field>

                <b-field label="Piattaforma">
                  <b-select ref="iPlatform" v-model="vGame.PlatformId" required validation-message="Obbligatorio!">
                    <option v-for="x in lovs.platform" :value="x.Id" :key="x.Id">
                      {{ x.Platform }}
                    </option>
                  </b-select>
                </b-field>



                <b-field label="Voto">
                  <star-rating v-model="vGame.Dicks" :show-rating="false" :increment="0.5" :star-size="30" />
                </b-field>
              </div>
            </div>
            <div class="column">

              <b-field label="Commenti">
                <b-input type="textarea" v-model="vGame.Comment"></b-input>
              </b-field>
              <section>
                <div class="buttons">
                  <b-button @click="doSave" type="is-primary">Vai</b-button>
                  <b-button @click="doCancel" type="is-primary">Naaah</b-button>
                </div>
              </section>
            </div>

          </b-tab-item>
          <b-tab-item label="Aggiungi">
            <add-game @OkSearchRawg="doOkRawg" />
          </b-tab-item>
          <b-tab-item label="Ricerca" ref="form">
            <search-game @OkSearchGame="doOkSearch" />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

import AddGame from "@/components/AddGame";
import GameDetails from "@/components/GameDetails";
import StarRating from "vue-star-rating";
import SearchGame from "@/components/SearchGame";

let emptyVal = { Series: {} };

export default {
  name: "game",
  components: { AddGame, StarRating, GameDetails, SearchGame },
  methods: {
    filtersChange(filter) {
      this.filter = filter;
      this.getData();
      this.getTotal();
    },
    flattenGames(data) {
      let out = [];
      data.forEach((el) => {
        let statusName = helpers.lookupLOV(
          this.allLovs,
          "gameStatus",
          el.StatusId,
          "GameStatus"
        );
        let platformName = helpers.lookupLOV(
          this.allLovs,
          "platform",
          el.PlatformId,
          "Platform"
        );

        let or_title = el.OriginalTitle == el.Title?"id.":el.OriginalTitle;
        let title = `${el.Title} (${or_title})`;
        
        out.push({
          ...el,
          FullTitle: title,
          Status: statusName,
          Platform: platformName,
          DateBeginDate: this.isoDate(el.BeginDate * 1000),
          DateEndDate: this.isoDate(el.EndDate * 1000),
          DatePurchaseDate: this.isoDate(el.PurchaseDate * 1000)
        });
      });

      return out;
    },
    getData() {
      const loading = this.$buefy.loading.open();
      api.game
        .getPaginated(
          (this.page - 1) * 10,
          10,
          helpers.buildGamesFilter(this.filter, this.lovs),
          helpers.getGamesOrder(this.filter)
        )
        .then((rows) => {

          this.buildActiveLovs();
          this.rowData = this.flattenGames(rows.data);

          loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },

    buildActiveLovs() {
      this.lovs.gameStatus = this.allLovs.gameStatus.filter((x) => {
        return x.Active;
      });

      this.lovs.platform = this.allLovs.platform.filter((x) => {
        return x.Active;
      });
    },
    getTotal() {
      const loading = this.$buefy.loading.open();
      api.game.getTotal(helpers.buildGamesFilter(this.filter, this.lovs)).then((rows) => {
        this.total = rows.data;
        loading.close();
      }).catch((err) => {
        helpers.error("Errore! " + err);
        loading.close();
      });
    },

    isoDate(date) {
      if (date) return helpers.buildIsoDate(date)
      else return null;
    },
    doDelete() {
      this.$buefy.dialog.confirm({
        message: "Scancello sul serio?",
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.game
            .delete(this.gameDetails.Id)
            .then(() => {
              this.getData();
              this.getTotal();
              helpers.ok("Gioco correttamente scancellato");
              this.vGame = emptyVal;
              this.showGameDetails = false;
              loading.close();
            })
            .catch((err) => {
              helpers.error("Errore! " + err);
              loading.close();
            });
        },
      });
    },
    doOkRawg(rawgData) {
      this.vGame.Title = rawgData.name
      this.vGame.OriginalTitle = rawgData.name
      this.vGame.ExtId = rawgData.id.toString()
      this.vGame.DatePurchaseDate = new Date()
      this.vGame.PlatformId = helpers.lookupLOVByVal(this.allLovs, "platform", "Switch", "Platform")
      this.vGame.StatusId = helpers.lookupLOVByVal(this.allLovs, "gameStatus", "In coda", "GameStatus")
      this.selectedTab = 1;
    },
    doCancel() {
      this.vGame.DateBeginDate = this.isoDate(this.vGame.DateBegin * 1000);
      this.vGame.DateBeginEnd = this.isoDate(this.vGame.DateEnd * 1000);
      this.vGame = emptyVal;
      this.selectedTab = 0;
    },
    doOkSearch(filterModel) {
      this.filter = filterModel;
      this.selectedTab = 0;
      this.getData();
      this.getTotal();
    },
    doClearSearch() {
      this.doOkSearch({});
    },
    doSearchPast() {
      this.filter = { Timeline: 'past' };
      this.doOkSearch(this.filter);
    },
    doSearchPresent() {
      this.filter = { Timeline: 'present' };
      this.doOkSearch(this.filter);
    },
    doSearchFuture() {
      this.filter = { Timeline: 'future' };
      this.doOkSearch(this.filter);
    },
    doNew() {
      this.selectedTab = 2;
    },
    doSave() {
      if (
        !this.$refs["iTitolo"].checkHtml5Validity() ||
        !this.$refs["iTitoloOr"].checkHtml5Validity() ||
        !this.$refs["iStatus"].checkHtml5Validity() ||
        !this.$refs["iDatePurchase"].checkHtml5Validity() ||
        !this.$refs["iPlatform"].checkHtml5Validity()
      ) {
        helpers.error("C'è qualcosa che non va nelle validazioni!");
        return;
      }

      let apiMethod = this.vGame.Id ? api.game.update : api.game.create;

      const loading = this.$buefy.loading.open();
      apiMethod(this.vGame)
        .then(() => {
          this.getData();
          this.getTotal();
          this.vGame = emptyVal;
          this.selectedTab = 0;
          loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },
    doEdit() {
      this.vGame = this.gameDetails;
      if (this.vGame.DateBeginDate)
        this.vGame.DateBeginDate = new Date(this.vGame.BeginDate * 1000);
      if (this.vGame.DateEndDate)
        this.vGame.DateEndDate = new Date(this.vGame.EndDate * 1000);
      if (this.vGame.DatePurchaseDate)
        this.vGame.DatePurchaseDate = new Date(this.vGame.PurchaseDate * 1000);
      this.showGameDetails = false;
      this.buildActiveLovs();
      this.selectedTab = 1;
    },

    rowClicked(row) {
     const loading = this.$buefy.loading.open();
      api.game
        .details(row.ExtId)
        .then((rgame) => {
          this.gameDetails = row;
          this.gameDetails.rawg = rgame.data;
          this.gameDetails.devString = rgame.data.developers
            .map((x) => x.name)
            .join(", ");
          // this.seriesDetails.created_by = rgame.data.created_by.map((x) => x.name)
          //   .join(", ");
          this.showGameDetails = true;
          loading.close();
        })

    },
    select(row) {
      this.newItem = row;
      this.selected = row;
    },
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vGame: emptyVal,
      rowData: [],
      mRowData: [],
      rawgData: [],
      selected: null,
      lovs: {},
      allLovs: {},
      selectedTab: 0,
      imdbName: "",
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      showGameDetails: false,
      gameDetails: { },
     
      columns: [
        {
          field: "Id",
          label: "Id",
          width: "30",
          numeric: true,
        },
        {
          field: "FullTitle",
          label: "Titolo",
          searchable: true
        },
        {
          field: "DateBeginDate",
          label: "Iniziata il",
          width: "100px",
        },
        {
          field: "DateEndDate",
          label: "Finita il",
          width: "100px",
        },
        {
          field: "DatePurchaseDate",
          label: "Acquisito il",
          width: "100px",
        },
        {
          field: "Platform",
          label: "Piattaforma",
          searchable: true
        },
        {
          field: "Status",
          label: "Stato",
          width: "120px",
          searchable: true
        },
        {
          field: "Dicks",
          label: "Voto",
          width: "50px",
          searchable: true
        },
        {
          field: "ExtId",
          label: "ExId",
          visible: false,
        },

      ],
    };
  },
  mounted() {

    const loading = this.$buefy.loading.open();
    if (!this.allLovs.gameStatus) {
      api.lovs().then((data) => {
        this.allLovs.platform = data.data.platforms;
        this.allLovs.gameStatus = data.data.gameStatuses;
        this.buildActiveLovs();

        this.getTotal();
        this.getData();
        loading.close();
      });
    } else {

      this.getTotal();
      this.getData();
      loading.close();
    }

  },
};
</script>

<style></style>

